var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{attrs:{"light":""}},[_c('PrivateLayout')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }